module.exports = __webpack_public_path__ + "img/brand (2).de32dcf4.svg";